import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiConfiguration } from '../api-configuration';
import { Observable } from 'rxjs';
import { ApiResponse } from '../api-response.model';
import {
  CompanyDto,
  CompanyList,
  CompanyListDto,
  CompanyStatisticsDto,
  CreateCompanyDto,
} from '../fn/generals/company.model';
import { CompanyAdmin } from 'src/app/shared/model/admin';

@Injectable({
  providedIn: 'root',
})
export class CompanyService {
  constructor(private http: HttpClient, private config: ApiConfiguration) {}

  getAllActive(): Observable<ApiResponse<{ companys: CompanyAdmin[] }>> {
    const url = `${this.config.rootUrl}/compania/activos`;
    return this.http.get<ApiResponse<{ companys: CompanyAdmin[] }>>(url);
  }

  getCompanyById(idCompany: string): Observable<ApiResponse<CompanyDto>> {
    const url = `${this.config.rootUrl}/compania/obtener-por-id/${idCompany}`;
    return this.http.get<ApiResponse<CompanyDto>>(url);
  }

  getCompanyStatistics(
    idCompany: string
  ): Observable<ApiResponse<CompanyStatisticsDto>> {
    const url = `${this.config.rootUrl}/compania/obtener-estadisticas-oferta-empleo/${idCompany}`;
    return this.http.get<ApiResponse<CompanyStatisticsDto>>(url);
  }

  createCompany(company: CreateCompanyDto): Observable<ApiResponse<any>> {
    const url = `${this.config.rootUrl}/compania`;

    const formData = new FormData();
    formData.append('idBusinessLine', company.idBusinessLine);
    formData.append('idDistrict', company.idDistrict);
    formData.append('email', company.email);
    formData.append('commercialName', company.commercialName);
    formData.append('socialReason', company.socialReason);
    formData.append('ruc', company.ruc);

    company.representatives.forEach((rep, i) => {
      formData.append(`representatives[${i}]`, rep);
    });
    if (company.urlBannerMiniPage) {
      formData.append('urlBannerMiniPage', company.urlBannerMiniPage);
    }

    return this.http.post<ApiResponse<any>>(url, formData);
  }

  sendVerificationCode(
    email: string,
    idCompany: string
  ): Observable<ApiResponse<any>> {
    const params = new HttpParams()
      .set('idCompany', idCompany)
      .set('email', email);

    return this.http.get<ApiResponse<any>>(
      `${this.config.rootUrl}/compania/enviar-codigo-verificacion`,
      { params }
    );
  }

  updateEmail(
    id: string,
    email: string,
    code: string
  ): Observable<ApiResponse<any>> {
    const url = `${this.config.rootUrl}/compania/correo/${id}`;

    const body = {
      email: email,
      verificationcode: code,
    };

    return this.http.patch<ApiResponse<any>>(url, body);
  }

  verifyCompany(
    idCompany: string,
    verificationCode: string
  ): Observable<ApiResponse<any>> {
    const url = `${this.config.rootUrl}/compania/verificar/${idCompany}?verificationcode=${verificationCode}`;
    return this.http.get<ApiResponse<any>>(url);
  }

  getCompaniesByUserId(): Observable<ApiResponse<CompanyListDto>> {
    return this.http.get<ApiResponse<CompanyListDto>>(
      `${this.config.rootUrl}/compania/obtener-por-id-usuario`
    );
  }

  updateCompanyBasicData(
    idCompany: string,
    data: Partial<{
      idBusinessLine: string;
      idDistrict?: string;
      email: string;
      commercialName: string;
      socialReason: string;
      ruc: string;
    }>
  ): Observable<ApiResponse<any>> {
    const url = `${this.config.rootUrl}/compania/${idCompany}`;
    return this.http.patch<ApiResponse<any>>(url, data);
  }

  updateCompanyMiniPageData(
    idCompany: string,
    data: Partial<{
      urlBannerMiniPage: string;
      urlBannerMvv: string;
      urlBannerOurHistory: string;
      urlVideo: string;
      urlUbication: string;
      mission: string;
      vision: string;
      valuesProperty: string;
      businessInformation: string;
      ourHistory: string;
      slogan: string;
    }>
  ): Observable<ApiResponse<any>> {
    const url = `${this.config.rootUrl}/compania/informacion/${idCompany}`;
    return this.http.patch<ApiResponse<any>>(url, data);
  }

  updateUrlBannerMiniPage(idCompany: string, file: File): Observable<any> {
    const url = `${this.config.rootUrl}/compania/logo/${idCompany}`;
    const formData = new FormData();
    formData.append('urlBannerMiniPage', file);
    return this.http.post(url, formData);
  }

  updateUrlBannerMvv(idCompany: string, file: File): Observable<any> {
    const url = `${this.config.rootUrl}/compania/banner/${idCompany}`;
    const formData = new FormData();
    formData.append('urlBannerMvv', file);
    return this.http.post(url, formData);
  }

  updateUrlBannerOurHistory(idCompany: string, file: File): Observable<any> {
    const url = `${this.config.rootUrl}/compania/historia/${idCompany}`;
    const formData = new FormData();
    formData.append('urlBannerOurHistory', file);
    return this.http.post(url, formData);
  }

  updateCompany(
    idCompany: string,
    data: any
  ): Observable<ApiResponse<CompanyDto>> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Accept: 'application/json',
    });

    const url = `${this.config.rootUrl}/compania/${idCompany}`;
    return this.http.patch<ApiResponse<CompanyDto>>(url, data, { headers });
  }

  removeAllInactiveCompanies(): Observable<any> {
    const url = `${this.config.rootUrl}/compania/eliminar-inactivos`;
    return this.http.delete(url, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    });
  }
}
